import "@assets/js/pinyinUtil";
import ruleFormCom from "@components/tableRuleForm/tableRuleForm";
import m2_examRegMenu from '@components/examRegMenu/m2_examRegMenu.vue'
import m1_examRegMenu from '@components/examRegMenu/m1_examRegMenu.vue'
import m1_subExamRegMenu from '@components/subExamRegMenu/m1_subExamRegMenu.vue'
import m2_subExamRegMenu from '@components/subExamRegMenu/m2_subExamRegMenu.vue'
import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
    components: {
        'm2ExamRegMenu': m2_examRegMenu,
        "m2Sidebar": m2Sidebar,
        "examRegMenu": m1_examRegMenu,
        "subExamRegMenu": m1_subExamRegMenu,
        "m2SubExamRegMenu": m2_subExamRegMenu,
        'ruleFormCom': ruleFormCom
    },
    data() {
        return {
            DateOpt: {
                disabledDate: time => {
                    let isDate = new Date(
                        this.$common.formatDate(time, "yyyy-MM-dd")
                    );
                    if (this.dateLimit.begin_datetime) {
                        if (this.dateLimit.end_datetime) {
                            return (
                                isDate.getTime() >
                                new Date(
                                    this.dateLimit.end_datetime
                                ).getTime() ||
                                isDate.getTime() <
                                new Date(
                                    this.dateLimit.begin_datetime
                                ).getTime()
                            );
                        }
                        return (
                            isDate.getTime() <
                            new Date(this.dateLimit.begin_datetime).getTime()
                        );
                    }
                    if (this.dateLimit.end_datetime) {
                        return (
                            isDate.getTime() >
                            new Date(this.dateLimit.end_datetime).getTime()
                        );
                    }
                }
            },
            validCardId: (rule, value, callback) => {
                var cardType = null;
                this.ruleForm.field.forEach(item => {
                    if (item._item_type == "cert_type") {
                        cardType = item.value;
                    }
                });
                if (cardType == "居民身份证") {
                    if (!this.$common.validateChinaCt(value)) {
                        callback(new Error("证件号码不正确"));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            validZipCode: (rule, value, callback) => {
                var re = /^[0-9]{6}$/;
                if (re.test(value)) {
                    callback();
                } else {
                    callback(new Error("邮政编码不正确"));
                }
            },
            validMobileNum: (rule, value, callback) => {
                if (value != "") {
                    if (this.isMobileChange) {
                        if (this.$common.validMobileNum(value)) {
                            callback();
                        } else {
                            callback(new Error("手机号不正确"));
                        }
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            validEmail: (rule, value, callback) => {
                if (value != "") {
                    if (this.isEmailChange) {
                        if (this.$common.validEmail(value)) {
                            callback();
                        } else {
                            callback(new Error("邮箱号不正确"));
                        }
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            isMobileChange: false,
            isEmailChange: false,
            ruleForm: {
                field: []
            },
            tableRuleForm: {
                field: []
            },
            dateLimit: {},
            promiseState: 0,
            batchNum: 0,
            btnDisable: false,
            operatorTableIndex: "", //当前操作的表格index
            editTableRowIdx: "", //当前操作的表格value值index
            btnName: "add", //add为添加，edit为编辑
            dialogVisible: false,
            pinYinDialog: false,
            pinYinShow: false,
            errorMessage: ""
        };
    },
    methods: {
        handleEncryption(item) {
            if (item._item_type == "mobile_num") {
                this.isMobileChange = true;
            } else if (item._item_type == "email") {
                this.isEmailChange = true;
            }
        },
        getFormData(val) {
            this.dialogVisible = false;
            this.ruleForm.field.map(item => {
                if (item.index == this.operatorTableIndex) {
                    if (this.btnName == "add") {
                        item.value.push(val);
                    } else {
                        item.value.splice(this.editTableRowIdx, 1, val);
                    }
                }
            });
        },
        editTableRow(idx, row, item) {
            this.editTableRowIdx = idx;
            this.operatorTableIndex = item.index;
            item.sections.forEach(item => {
                Object.keys(row).forEach(key => {
                    if (key == item.tag) {
                        item.value = row[key];
                    }
                });
            });
            this.tableRuleForm.field = item.sections;
            this.btnName = "edit";
            this.dialogVisible = true;
        },
        delTableRow(idx, row, item) {
            this.$confirm("是否确定删除？", "提示信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.editTableRowIdx = idx;
                    this.operatorTableIndex = item.index;
                    this.ruleForm.field.map(item => {
                        if (item.index == this.operatorTableIndex) {
                            item.value.splice(this.editTableRowIdx, 1);
                        }
                    });
                })
                .catch(() => { });
        },

        addTableInfo(item) {
            this.operatorTableIndex = item.index;
            this.tableRuleForm.field = item.sections;
            this.tableRuleForm.field.forEach(item => {
                item.value = '';
            })
            this.btnName = "add";
            this.dialogVisible = true;
        },
        handleClose(val) {
            this.dialogVisible = val;
        },
        getData: function () {
            let examRegInfo =  JSON.parse(JSON.stringify(this.$store.state.examRegInfo.examRegInfo));
            if (examRegInfo === null) {
                this.$router.push({
                    name: "default.examReg.chooseBatch"
                });
            }
            examRegInfo.text_info_confs.forEach(item => {
                if (item._item_type == "name" && !item.py_value) {
                    this.getPinYIn(item);
                }
                if (item.type == 4) {
                    item.value = item.value;
                }
                if (item.type == 8) {
                    item.value = item.value == "" ? [] : item.value;
                }
                if (item.type == 7) {
                    if (typeof item.value == "string") {
                        let list = [];
                        item.value.split("/").forEach((n, index) => {
                            list.push(
                                item.value
                                    .split("/")
                                    .slice(0, index + 1)
                                    .join("/")
                            );
                        });

                        item.value = list;
                    }
                }
            });
            let text_info_confs = examRegInfo.text_info_confs;
            // 将type8类型置于最后
            text_info_confs = this.moveMaxType(text_info_confs);
            this.ruleForm.field = text_info_confs;
        },
        // 将最大数放到最后一个
        moveMaxType: function (arr) {
            let maxTypeArr = [];
            arr.map((item, idx, arr) => {
                if (item.type == 8) {
                    maxTypeArr.push(item);
                    arr.splice(idx, 1);
                }
            });
            arr.push(...maxTypeArr);
            return arr;
        },
        changePy(item) {
            item.py_value = item.py_value.toUpperCase();
            this.ruleForm.field.splice(
                this.ruleForm.field.indexOf(item),
                1,
                item
            );
            this.errorMessage = item.py_value ? "" : '姓名拼音不能为空';
        },
        displayRule(item) {
            if (item.rules.length > 0) {
                for (let i of item.rules) {
                    for (let j of this.ruleForm.field) {
                        if (j.tag == i.tag) {
                            if (displayRuleType[i.condition]) {
                                if (j.type == 3) {
                                    let states = true;
                                    for (let option of i.value) {
                                        if (j.value.indexOf(option) == -1) {
                                            states = false;
                                        }
                                    }
                                    if (!states) {
                                        if (item.type == 8) {
                                            item.value = [];
                                        } else {
                                            item.value = "";
                                        }
                                        item.is_pass = false;
                                        return false;
                                    }
                                } else {
                                    if (i.value.indexOf(j.value) == -1) {
                                        if (item.type == 8) {
                                            item.value = [];
                                        } else {
                                            item.value = "";
                                        }
                                        item.is_pass = false;
                                        return false;
                                    }
                                }
                            } else {
                                if (!j.value) {
                                    if (item.type == 8) {
                                        item.value = [];
                                    } else {
                                        item.value = "";
                                    }
                                    item.is_pass = false;
                                    return false;
                                }
                            }
                        }
                    }
                }
                item.is_pass = true;
                return true;
            } else {
                item.is_pass = true;
                return true;
            }
        },
        setDefaultTime: function (item) {
            let d1 = new Date(item.begin_datetime);
            let d2 = new Date(item.end_datetime);
            if (item.begin_datetime && item.end_datetime) {
                let d3 = new Date((d2.getTime() + d1.getTime()) / 2);
                return d3;
            } else if (item.begin_datetime) {
                let d3 = new Date(d1.getTime() + 3600000 * 24);
                return d3;
            } else if (item.end_datetime) {
                let d3 = new Date(d2.getTime() - 3600000 * 24);
                return d3;
            } else {
                return "";
            }
        },
        setDateLimit: function (item) {
            this.dateLimit = item.sub_confs;
        },

        preStep: function () {
            if (this.$store.state.examRegInfo.promiseState) {
                this.$router.push({
                    name: "default.examReg.examNotes"
                });
            } else if (this.$store.state.examInfo.batch > 1) {
                this.$router.push({
                    name: "default.examReg.chooseBatch"
                });
            }
        },
        getPinYIn: function (item) {
            if (item.sub_confs.enable_pinyin) {
                var n = pinyinUtil.getPinyin(item.value).toUpperCase();
                var j,
                    num = 0;
                if (n) {
                    for (let i of n.split(" ")) {
                        if (n.indexOf(i) == 0 && num == 0) {
                            num++;
                            j = i + " ";
                        } else {
                            j = j + i;
                        }
                    }
                }
                item.py_value = j;
                // var pinyin = require("pinyin");
                // var i = pinyin(item.value, {
                //     style: pinyin.STYLE_NORMAL
                // });
                // var j = "";
                // if (i.length <= 2) {
                //     j = i.join(" ").toUpperCase();
                // } else {
                //     for (let item in i) {
                //         if (item == 0) {
                //             j = i[item] + " ";
                //         } else {
                //             j = j + i[item]
                //         }
                //     }
                //     j = j.toUpperCase();
                // }
                // item.py_value = j;
            }
        },
        checkPinYinDialog() {
            this.ruleForm.field.forEach(item => {
                if (item.sub_confs) {
                    if (item.sub_confs.enable_pinyin) {
                        this.pinYinShow = true;
                    }
                }
            })
            if (this.pinYinShow) {
                this.pinYinDialog = true;
            } else {
                this.confirmNextStep();
            }
        },
        confirmPinyin() {
            if (!this.errorMessage) {
                this.pinYinShow = false;
                this.pinYinDialog = false;
                this.confirmNextStep();
            }
        },
        confirmNextStep: function () {
            let examRegInfo = this.$store.state.examRegInfo.examRegInfo;

            this.$store.commit("setExamRegInfoItem", {
                text_info_confs: this.ruleForm.field
            });
            let formData = [];
            this.ruleForm.field.forEach(item => {
                if (item.is_pass) {
                    if (item.type == 4) {
                        formData.push({
                            name: item.name,
                            value: item.value,
                            type: item.type,
                            _item_type: item._item_type,
                            tag: item.tag,
                            is_required: item.is_required
                        });
                    } else if (item.type == 7) {
                        formData.push({
                            name: item.name,
                            value: item.value.length == 0 ? item.value.length : item.value[item.value.length - 1],
                            type: item.type,
                            _item_type: item._item_type,
                            tag: item.tag,
                            is_required: item.is_required
                        });
                    } else if (
                        item.type == 1 &&
                        item.sub_confs.enable_pinyin
                    ) {
                        formData.push({
                            name: item.name,
                            value: item.value,
                            py_value: item.py_value,
                            type: item.type,
                            _item_type: item._item_type,
                            tag: item.tag,
                            is_required: item.is_required
                        });
                    } else {
                        formData.push({
                            name: item.name,
                            value: item.value,
                            type: item.type,
                            _item_type: item._item_type,
                            tag: item.tag,
                            is_required: item.is_required
                        });
                    }
                }
            });
            this.$http
                .post(globalProvider.serviceUrl("e_reg/us/rgsi/t"), {
                    eri: examRegInfo.exam_registration_id,
                    i: formData
                })
                .then(data => {
                    this.btnDisable = false;
                    if (data.body.code === resultCode.Success) {
                        if (examRegInfo.pic_info_confs.length > 0) {
                            this.$router.push({
                                name: "default.examReg.imgCollection"
                            });
                        } else if (
                            examRegInfo.file_info_confs.length > 0
                        ) {
                            this.$router.push({
                                name: "default.examReg.fileCollection"
                            });
                        } else {
                            if (
                                examRegInfo.reg_mode ==
                                reg_mode.region_subject
                            ) {
                                this.$router.push({
                                    name: "default.examReg.chooseExamRegion"
                                });
                            } else {
                                this.$router.push({
                                    name: "default.examReg.chooseSubject2"
                                });
                            }
                        }
                    } else if (
                        data.body.code == resultCode.NotSuccess
                    ) {
                        if (data.body.message == "E_REG_LIMIT_RULES") {
                            this.$alert(
                                data.body.data,
                                "提示", {
                                confirmButtonText: "确定"
                            }
                            );
                        } else {
                            this.$alert(
                                getErrorMessage(data.body.message),
                                "提示", {
                                confirmButtonText: "确定"
                            }
                            );
                        }

                    }
                });
        },
        nextStep: function () {
            this.$store.commit("setBackOrNextStep", "next");
            this.btnDisable = true;
            let examRegInfo = this.$store.state.examRegInfo.examRegInfo;
            this.$refs["ruleForm"].validate((valid, object) => {
                for (let i in object) {
                    let dom = this.$refs[i];
                    if (Object.prototype.toString.call(dom) !== '[object Object]') {
                        dom = dom[0];
                    }
                    dom.$el.scrollIntoView({　　//滚动到指定节点
                        block: 'center',　　　　　//值有start,center,end，nearest，当前显示在视图区域中间
                        behavior: 'smooth'　　　　//值有auto、instant,smooth，缓动动画（当前是慢速的）
                    })
                    break;
                }
                if (valid) {
                    this.checkPinYinDialog();
                } else {
                    this.btnDisable = false;
                }
            });
        },
        getRules: function (item) {
            // 证件号码验证，仅当证件类型为居民身份证时验证格式
            if (item.type == 1 && item._item_type == "cert_id") {
                if (item.is_required) {
                    return [{
                        required: true,
                        message: item.name + "不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: this.validCardId,
                        trigger: "blur"
                    }
                    ];
                } else {
                    return [{
                        validator: this.validCardId,
                        trigger: "blur"
                    }];
                }
            }
            if (
                item.type == 1 &&
                item._item_type == "zip_code" &&
                item.is_required
            ) {
                if (item.is_required) {
                    return [{
                        required: true,
                        message: item.name + "不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: this.validZipCode,
                        trigger: "blur"
                    }
                    ];
                } else {
                    return [{
                        validator: this.validZipCode,
                        trigger: "blur"
                    }];
                }
            }
            if (item.type == 1 && item._item_type == "mobile_num") {
                // this.$refs[item.tag].focus()
                if (item.is_required) {
                    return [{
                        required: true,
                        message: item.name + "不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: this.validMobileNum,
                        trigger: "blur"
                    }
                    ];
                } else {
                    return [{
                        validator: this.validMobileNum,
                        trigger: "blur"
                    }];
                }
            }
            if (item.type == 1 && item._item_type == "email") {
                if (item.is_required) {
                    return [{
                        required: true,
                        message: item.name + "不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: this.validEmail,
                        trigger: "blur"
                    }
                    ];
                } else {
                    return [{
                        validator: this.validEmail,
                        trigger: "blur"
                    }];
                }
            }
            // 下面4种为标准表单验证
            if (item.type == 1 && item.is_required) {
                return {
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "blur"
                };
            } else if (item.type == 2 && item.is_required) {
                return {
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            } else if (item.type == 3 && item.is_required) {
                return {
                    type: "array",
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            } else if (item.type == 4 && item.is_required) {
                return {
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            } else if (item.type == 7 && item.is_required) {
                return {
                    type: "array",
                    required: true,
                    message: item.name + "不能为空",
                    trigger: "change"
                };
            }
        },
        getPinyinRules: function (item) {
            if (item.type == 1 && item.sub_confs.enable_pinyin) {
                return {
                    required: true,
                    message: item.name + "拼音不能为空",
                    trigger: "blur"
                };
            }
        }
    },
    created: function () {
        this.$store.commit("setHeaderState", "3");
        this.batchNum = this.$store.state.examInfo.batch;
        this.promiseState = this.$store.state.examRegInfo.promiseState;
        this.getData();
    }
};